import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-735a63c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["name", "id", "value", "checked", "disabled"]
const _hoisted_2 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["radio", { disabled: $props.disabled }])
  }, [
    _createElementVNode("input", {
      type: "radio",
      name: $props.groupName,
      id: `radio-${$props.groupName}-${$props.value}`,
      value: $props.value,
      checked: $props.value === $props.modelValue,
      onChange: _cache[0] || (_cache[0] = ($event: any) => ($setup.emits('update:modelValue', $props.value))),
      disabled: $props.disabled,
      class: _normalizeClass({ disabled: $props.disabled })
    }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_1),
    _createElementVNode("label", {
      for: `radio-${$props.groupName}-${$props.value}`,
      class: _normalizeClass({ disabled: $props.disabled })
    }, _toDisplayString($props.text), 11 /* TEXT, CLASS, PROPS */, _hoisted_2)
  ], 2 /* CLASS */))
}